import {
  type ProductId,
  availableSiteToProductName,
  availableSiteToSubProductName,
} from '../site-types';

export const toProductName = (availableSite: string) =>
  availableSiteToProductName[availableSite as ProductId];

export const toSubProductName = (availableSite: string) =>
  availableSiteToSubProductName[availableSite as ProductId];
